import React, { useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import { ModalContext } from 'App';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import * as c from '../constant';
import * as actions from '../action';
import TaxpayerDropdown from './TaxpayerDropdown';

const BusinessAssignModal = ({
  updateBusinessAssign,
  id,
  updating,
  getSingleNewBusinesses,
}) => {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState({
    taxpayer_id: '',
  });

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      ...formData,
      taxpayer_id: +_.get(formData, 'taxpayer_id'),
    };

    return updateBusinessAssign(id, args, () => {
      setModal({ isOpen: false });
      getSingleNewBusinesses(id);
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="full-label mb-3">
              Search Taxpayer by: Mobile number, Email or Name
            </label>
            <TaxpayerDropdown
              name="taxpayer_id"
              onChange={onChange}
              value={_.get(formData, 'taxpayer_id') || ''}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          >
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
};

BusinessAssignModal.propTypes = {
  updateBusinessAssign: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  id: PropTypes.number.isRequired,
  getSingleNewBusinesses: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_BUSINESS_ASSIGN) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(BusinessAssignModal);
